import React from 'react'
import { Input as AriaInput, InputProps } from 'react-aria-components'

import './Input.css'

type Props = Omit<InputProps, 'size'> & {
  size?: 'default' | 'small'
}

export function Input({ size = 'default', ...props }: Props) {
  return <AriaInput data-size={size} {...props} />
}
